import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="ReactJS Projects" link="https://github.com/K-G-PRAJWAL/ReactJS-Projects" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
ReactJS is one of the most popular JavaScript framework. The projects in this repo have been created using ReactJS.
    </ProjectCard>
    <ProjectCard title="Data Science Projects" link="https://github.com/K-G-PRAJWAL/Data-Science-Projects" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
Data Science is called the 'Sexiest Job' of 21st century. This repo contains some of the Data Science projects I've worked on.
    </ProjectCard>
    <ProjectCard title="Python Projects" link="https://github.com/K-G-PRAJWAL/Python-Projects" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
Python is regarded as the most popular language. This repo contains some beautiful projects that shows the capability of python.
    </ProjectCard>
    <ProjectCard title="ExpressJS Projects" link="https://github.com/K-G-PRAJWAL/ExpressJS-Projects" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
ExpressJS is a NodeJS web application framework. This repo contains some amazing ExpressJS Projects.
    </ProjectCard>
    <ProjectCard title="HTML, CSS & JS Projects" link="https://github.com/K-G-PRAJWAL/HTML-CSS-Projects" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
Some simple yet complicated web applications built just out of HTML, CSS & JS.
    </ProjectCard>
    <ProjectCard title="Machine Learning Projects" link="https://github.com/K-G-PRAJWAL/Machine-Learning-Projects" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
"A breakthrough in Machine Learning is worth ten MicroSofts" is what Bill Gates once said. This repo is home for some wonderful machine learning projects.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      